import React, {useContext} from "react";
import "./ClaimOverview.scss";
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {AppContext} from "../../context/AppContext";
import moment from "moment-timezone";

const ClaimOverview = () => {
  const { phoneSearchResultState, translations, setDisableButton, setShowButtonCheckMark } = useContext(AppContext);

  setDisableButton(true); // Do not allow clicking the button here
  setShowButtonCheckMark(false);
  let headers = [];
  if(translations) {
     headers = translations.claimDetailsHeadings.split(",");
  }

  const rows = () => {
    const showClaims = phoneSearchResultState.data
      ? phoneSearchResultState.data
      : [];

    Object.keys(showClaims).map(id => {
      const claim = showClaims[id];
      var m = moment.utc(claim.lastUpdate, "DD-MM-YYYY h:mm:ss A");
      var lastUpdateWithTZ = m.clone().tz("Asia/Tokyo").format("YY/MM/DD (HH:mm)");
      claim.lastUpdate = lastUpdateWithTZ ? lastUpdateWithTZ: "N/A";
     });

    return showClaims;
  };

  const guidTemplate = (claim) => {
    const claimId = claim['claimId'];
    const guid = claim['id'];
    const salesForceId = claim['salesforceID']
    return <Link to={"/" + guid + "/" + salesForceId}>{claimId}</Link>
 }

  const renderEmptyState = () => {
    if(translations.noFNOLMessage !== "null") {
      return (
        <div className="overview-empty-state">{translations.noFNOLMessage}</div>
      );
    } else {
      return '';
    }

  };

  return (
    <div className="search-results-container">
        {phoneSearchResultState.data &&
          phoneSearchResultState.data.length > 0 ? (
            <DataTable value={rows()}  >
              <Column field="id" header="Id" hidden></Column>
              <Column field="claimId" header={headers[0]} body={guidTemplate}></Column>
              <Column field="lastUpdate" header={headers[1]}></Column>
              <Column field="sent" header={headers[2]}></Column>
            </DataTable>
          ) : (
            renderEmptyState()
          )}
    </div>
  );
};

export default ClaimOverview;
